import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../core/auth/services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(public _authenticationService: AuthenticationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const reqUrl = req.url as any;
    if (reqUrl.match(/auth\/login_check|auth\/password\/reset|auth\/sso\/saml\/exchange|init\/permissions/)) {
      return next.handle(req);
    }
    if (this._authenticationService.isTokenValid$()) {
      const header = {
        Authorization: `Bearer ${this._authenticationService.jwt$().token}`,
      };
      if (localStorage.getItem('userImpersonated')) {
        header['x-switch-user'] = localStorage.getItem('userImpersonated');
      }
      req = req.clone({ setHeaders: header });
    }

    return next.handle(req);
  }
}
